package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Pitcairn Islands Flag (32x24dp)
 *
 * - ISO Alpha-2: PN
 * - ISO Alpha-3: PCN
 * - ISO Numeric: 612
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.PitcairnIslands: ImageVector by lazy {
    ImageVector.Builder(
        name = "Pitcairn Islands:PN:PCN:612:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(18f)
                verticalLineToRelative(14f)
                horizontalLineToRelative(-18f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFF2E42A5))) {
                moveTo(0f, 0f)
                horizontalLineToRelative(18f)
                verticalLineToRelative(14f)
                horizontalLineToRelative(-18f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(-2.004f, 13f)
                lineTo(1.957f, 14.737f)
                lineTo(18.09f, 1.889f)
                lineTo(20.179f, -0.693f)
                lineTo(15.943f, -1.273f)
                lineTo(9.363f, 4.263f)
                lineTo(4.067f, 7.994f)
                lineTo(-2.004f, 13f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(-1.462f, 14.217f)
                lineTo(0.556f, 15.225f)
                lineTo(19.429f, -0.933f)
                horizontalLineTo(16.596f)
                lineTo(-1.462f, 14.217f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(20.004f, 13f)
                lineTo(16.043f, 14.737f)
                lineTo(-0.09f, 1.889f)
                lineTo(-2.179f, -0.693f)
                lineTo(2.056f, -1.273f)
                lineTo(8.637f, 4.263f)
                lineTo(13.933f, 7.994f)
                lineTo(20.004f, 13f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(19.869f, 13.873f)
                lineTo(17.851f, 14.882f)
                lineTo(9.815f, 7.964f)
                lineTo(7.432f, 7.191f)
                lineTo(-2.38f, -0.684f)
                horizontalLineTo(0.453f)
                lineTo(10.26f, 7.004f)
                lineTo(12.865f, 7.931f)
                lineTo(19.869f, 13.873f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.985f, 0f)
                horizontalLineTo(7.985f)
                verticalLineTo(6f)
                horizontalLineTo(0f)
                verticalLineTo(8f)
                horizontalLineTo(7.985f)
                verticalLineTo(14f)
                horizontalLineTo(9.985f)
                verticalLineTo(8f)
                horizontalLineTo(18f)
                verticalLineTo(6f)
                horizontalLineTo(9.985f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.485f, 0f)
                horizontalLineTo(11.484f)
                verticalLineTo(4.5f)
                horizontalLineTo(18f)
                verticalLineTo(9.5f)
                horizontalLineTo(11.484f)
                lineTo(11.5f, 14f)
                horizontalLineTo(6.5f)
                lineTo(6.485f, 9.5f)
                horizontalLineTo(0f)
                verticalLineTo(4.5f)
                horizontalLineTo(6.485f)
                verticalLineTo(0f)
                close()
                moveTo(7.985f, 6f)
                horizontalLineTo(0f)
                verticalLineTo(8f)
                horizontalLineTo(7.985f)
                verticalLineTo(14f)
                horizontalLineTo(9.985f)
                verticalLineTo(8f)
                horizontalLineTo(18f)
                verticalLineTo(6f)
                horizontalLineTo(9.985f)
                verticalLineTo(0f)
                horizontalLineTo(7.985f)
                verticalLineTo(6f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFF5EAA22)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(20.616f, 10.757f)
            curveTo(20.616f, 10.757f, 20.715f, 11.852f, 20.498f, 12.472f)
            curveTo(20.282f, 13.092f, 20.172f, 13.452f, 20.172f, 13.056f)
            curveTo(20.172f, 12.659f, 20.02f, 12.345f, 19.897f, 12.345f)
            curveTo(19.775f, 12.345f, 19.872f, 12.738f, 19.749f, 12.738f)
            curveTo(19.626f, 12.738f, 19.203f, 12.806f, 19.203f, 12.575f)
            curveTo(19.203f, 12.345f, 19.147f, 13.193f, 19.422f, 13.269f)
            curveTo(19.696f, 13.345f, 19.288f, 13.581f, 19.106f, 13.508f)
            curveTo(19.106f, 13.508f, 19.855f, 13.751f, 20.149f, 13.959f)
            curveTo(20.149f, 13.959f, 21.03f, 15.059f, 21.854f, 14.925f)
            curveTo(21.854f, 14.925f, 20.732f, 14.537f, 20.93f, 13.797f)
            curveTo(21.128f, 13.057f, 21.854f, 12.95f, 21.854f, 12.95f)
            curveTo(21.854f, 12.95f, 22.195f, 13.064f, 22.185f, 13.363f)
            curveTo(22.175f, 13.662f, 22.435f, 13.269f, 22.435f, 13.269f)
            curveTo(22.435f, 13.269f, 22.476f, 12.892f, 22.43f, 12.8f)
            curveTo(22.384f, 12.708f, 23.211f, 12.529f, 23.264f, 12.141f)
            curveTo(23.264f, 12.141f, 22.418f, 12.179f, 22.36f, 12.08f)
            curveTo(22.302f, 11.98f, 22.622f, 11.823f, 22.522f, 11.628f)
            curveTo(22.422f, 11.434f, 20.93f, 12.738f, 20.93f, 12.738f)
            curveTo(20.93f, 12.738f, 21.445f, 11.85f, 21.445f, 11.374f)
            curveTo(21.445f, 10.897f, 21.314f, 10.571f, 20.93f, 10.571f)
            curveTo(20.546f, 10.571f, 20.616f, 10.757f, 20.616f, 10.757f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF5EAA22)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(28.383f, 11.017f)
            curveTo(28.382f, 11.019f, 28.385f, 11.02f, 28.386f, 11.019f)
            curveTo(28.441f, 10.964f, 28.784f, 10.649f, 29.071f, 10.898f)
            curveTo(29.384f, 11.17f, 28.913f, 11.435f, 28.913f, 11.435f)
            curveTo(28.913f, 11.435f, 29.133f, 11.649f, 29.385f, 11.649f)
            curveTo(29.637f, 11.649f, 29.698f, 11.435f, 29.698f, 11.435f)
            curveTo(29.698f, 11.435f, 29.718f, 11.91f, 30.539f, 12.09f)
            curveTo(30.539f, 12.09f, 30.832f, 11.67f, 30.539f, 11.439f)
            curveTo(30.539f, 11.439f, 30.885f, 11.368f, 30.86f, 11.087f)
            curveTo(30.86f, 11.087f, 30.575f, 11.184f, 30.372f, 10.961f)
            curveTo(30.17f, 10.738f, 29.774f, 10.636f, 29.486f, 10.687f)
            curveTo(28.757f, 10.424f, 28.428f, 10.939f, 28.383f, 11.017f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF96877D)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(23.404f, 13.415f)
            curveTo(23.404f, 13.415f, 24.253f, 15.012f, 23.722f, 15.343f)
            curveTo(23.191f, 15.674f, 26.246f, 15.439f, 26.534f, 15.343f)
            curveTo(26.822f, 15.248f, 26.476f, 14.744f, 26.156f, 14.604f)
            curveTo(25.837f, 14.465f, 24.525f, 13.999f, 24.176f, 13.649f)
            curveTo(23.827f, 13.298f, 24.04f, 13.173f, 24.321f, 12.827f)
            curveTo(24.602f, 12.481f, 25.643f, 12.342f, 25.643f, 12.018f)
            curveTo(25.643f, 11.695f, 26.303f, 10.359f, 26.765f, 10.259f)
            curveTo(27.226f, 10.158f, 26.977f, 9.999f, 26.871f, 9.999f)
            curveTo(26.765f, 9.999f, 26.127f, 10.657f, 25.885f, 10.538f)
            curveTo(25.643f, 10.42f, 25.614f, 10.428f, 25.885f, 10.141f)
            curveTo(26.156f, 9.855f, 26.361f, 9.525f, 26.002f, 9.762f)
            curveTo(25.643f, 9.999f, 25.052f, 10.375f, 24.767f, 10.375f)
            curveTo(24.483f, 10.375f, 23.471f, 10.247f, 23.597f, 10.538f)
            curveTo(23.722f, 10.83f, 23.775f, 11.335f, 24.321f, 11.677f)
            curveTo(24.867f, 12.018f, 24.63f, 12.268f, 24.176f, 12.597f)
            curveTo(23.722f, 12.927f, 23.404f, 13.415f, 23.404f, 13.415f)
            close()
        }
        path(fill = SolidColor(Color(0xFFFFD018))) {
            moveTo(29.039f, 11.303f)
            lineTo(27.42f, 14.548f)
            curveTo(27.42f, 14.548f, 27.373f, 15.465f, 28.53f, 14.854f)
            curveTo(29.687f, 14.243f, 29.641f, 13.81f, 29.975f, 13.81f)
            curveTo(30.309f, 13.81f, 30.414f, 13.625f, 30.414f, 13.625f)
            lineTo(30.192f, 13.45f)
            curveTo(30.192f, 13.45f, 30.167f, 13.131f, 30.307f, 13.06f)
            curveTo(30.307f, 13.06f, 30.031f, 12.908f, 29.992f, 13.035f)
            curveTo(29.952f, 13.161f, 29.758f, 12.769f, 29.868f, 12.769f)
            curveTo(29.868f, 12.769f, 29.624f, 13.163f, 29.573f, 13.317f)
            curveTo(29.573f, 13.317f, 29.221f, 13.174f, 29.238f, 12.51f)
            curveTo(29.254f, 11.847f, 29.039f, 11.303f, 29.039f, 11.303f)
            close()
        }
        path(fill = SolidColor(Color(0xFFFFD018))) {
            moveTo(21.336f, 10.789f)
            curveTo(21.336f, 10.789f, 20.512f, 10.981f, 20.601f, 11.18f)
            curveTo(20.69f, 11.38f, 20.821f, 11.175f, 20.418f, 11.415f)
            curveTo(20.418f, 11.415f, 19.709f, 11.963f, 19.555f, 11.904f)
            curveTo(19.4f, 11.845f, 19.664f, 12.042f, 19.664f, 11.415f)
            curveTo(19.664f, 10.789f, 19.252f, 11.299f, 19.664f, 10.88f)
            curveTo(20.075f, 10.462f, 20.22f, 10.789f, 20.418f, 10.548f)
            curveTo(20.616f, 10.307f, 20.438f, 10.435f, 20.975f, 10.435f)
            curveTo(21.511f, 10.435f, 21.336f, 10.789f, 21.336f, 10.789f)
            close()
        }
        path(fill = SolidColor(Color(0xFFFFD018))) {
            moveTo(23.851f, 14.014f)
            curveTo(23.851f, 14.014f, 21.544f, 15.827f, 21.083f, 15.962f)
            curveTo(20.621f, 16.098f, 22.031f, 15.925f, 22.375f, 15.686f)
            curveTo(22.719f, 15.446f, 23.851f, 14.014f, 23.851f, 14.014f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF5EAA22)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(28.425f, 17.195f)
            curveTo(28.425f, 17.195f, 28.646f, 18.623f, 28.068f, 18.482f)
            curveTo(27.49f, 18.342f, 27.25f, 18.269f, 27.25f, 18.269f)
            curveTo(27.25f, 18.269f, 27.462f, 18.934f, 27.765f, 18.934f)
            curveTo(27.765f, 18.934f, 28.281f, 19.941f, 28.083f, 20.258f)
            curveTo(28.083f, 20.258f, 28.972f, 19.537f, 28.828f, 18.963f)
            curveTo(28.684f, 18.39f, 29.058f, 19.058f, 29.058f, 19.058f)
            curveTo(29.058f, 19.058f, 29.385f, 19.216f, 29.622f, 19.039f)
            curveTo(29.858f, 18.863f, 29.619f, 18.941f, 29.382f, 18.605f)
            curveTo(29.146f, 18.269f, 29.204f, 17.326f, 28.485f, 16.837f)
            curveTo(27.765f, 16.348f, 27.597f, 16.363f, 27.597f, 16.363f)
            curveTo(27.597f, 16.363f, 27.068f, 15.497f, 27.385f, 15.554f)
            curveTo(27.385f, 15.554f, 29.66f, 16.334f, 29.719f, 16.534f)
            curveTo(29.778f, 16.734f, 30.382f, 16.697f, 30.08f, 16.126f)
            curveTo(29.778f, 15.554f, 28.152f, 15.21f, 27.958f, 15.049f)
            curveTo(27.765f, 14.887f, 27.945f, 14.276f, 27.597f, 14.143f)
            curveTo(27.25f, 14.01f, 26.3f, 13.065f, 26.301f, 12.609f)
            curveTo(26.302f, 12.154f, 25.855f, 11.939f, 25.466f, 11.939f)
            curveTo(25.078f, 11.939f, 24.346f, 11.827f, 24.037f, 11.827f)
            curveTo(23.728f, 11.827f, 23.44f, 12.344f, 23.738f, 12.344f)
            curveTo(24.037f, 12.344f, 23.782f, 13.312f, 23.282f, 13.524f)
            curveTo(22.782f, 13.735f, 22.396f, 14.039f, 21.825f, 14.039f)
            curveTo(21.254f, 14.039f, 22.633f, 14.532f, 22.853f, 14.337f)
            curveTo(23.072f, 14.143f, 23f, 13.853f, 23.738f, 13.524f)
            curveTo(24.476f, 13.194f, 25.181f, 12.999f, 25.092f, 13.262f)
            curveTo(25.003f, 13.524f, 25.23f, 13.962f, 25.578f, 13.804f)
            curveTo(25.926f, 13.645f, 26.037f, 13.244f, 26.037f, 13.524f)
            curveTo(26.037f, 13.804f, 26.57f, 15.241f, 26.978f, 15.802f)
            curveTo(27.385f, 16.363f, 28.425f, 17.195f, 28.425f, 17.195f)
            close()
        }
        path(fill = SolidColor(Color(0xFFFFD018))) {
            moveTo(23.571f, 11.946f)
            curveTo(23.571f, 11.946f, 23.301f, 12.377f, 23.571f, 12.377f)
            curveTo(23.842f, 12.377f, 24.277f, 12.377f, 24.012f, 12.161f)
            curveTo(23.747f, 11.946f, 23.571f, 11.946f, 23.571f, 11.946f)
            close()
        }
        path(fill = SolidColor(Color(0xFFFFD018))) {
            moveTo(24.475f, 11.935f)
            curveTo(24.475f, 11.935f, 24.476f, 12.222f, 24.664f, 12.222f)
            curveTo(24.851f, 12.222f, 25.018f, 12.508f, 25.018f, 12.222f)
            curveTo(25.018f, 11.935f, 25.279f, 12.03f, 24.877f, 11.935f)
            curveTo(24.475f, 11.84f, 24.475f, 11.935f, 24.475f, 11.935f)
            close()
        }
        path(fill = SolidColor(Color(0xFFFFD018))) {
            moveTo(25.63f, 12.001f)
            curveTo(25.63f, 12.001f, 25.449f, 12.137f, 25.539f, 12.38f)
            curveTo(25.63f, 12.622f, 25.834f, 13.103f, 25.539f, 13.103f)
            curveTo(25.244f, 13.103f, 25.002f, 13.276f, 25.232f, 13.276f)
            curveTo(25.462f, 13.276f, 25.872f, 13.449f, 25.872f, 13.276f)
            curveTo(25.872f, 13.103f, 26.039f, 13.561f, 26.039f, 13.276f)
            curveTo(26.039f, 12.99f, 26.039f, 12.854f, 26.039f, 12.686f)
            curveTo(26.039f, 12.519f, 26.205f, 12.471f, 26.039f, 12.236f)
            curveTo(25.872f, 12.001f, 25.63f, 12.001f, 25.63f, 12.001f)
            close()
        }
        path(fill = SolidColor(Color(0xFFFFD018))) {
            moveTo(26.047f, 13.672f)
            curveTo(26.047f, 13.672f, 26.424f, 14.857f, 26.629f, 15.01f)
            curveTo(26.833f, 15.163f, 26.925f, 16.45f, 27.015f, 16.59f)
            curveTo(27.105f, 16.73f, 28.33f, 17.437f, 28.33f, 17.816f)
            curveTo(28.33f, 18.195f, 28.707f, 17.524f, 28.518f, 17.149f)
            curveTo(28.33f, 16.774f, 27.736f, 15.974f, 27.309f, 15.8f)
            curveTo(26.882f, 15.626f, 26.936f, 15.204f, 26.847f, 14.907f)
            curveTo(26.757f, 14.61f, 27.378f, 15.147f, 26.847f, 14.474f)
            curveTo(26.315f, 13.801f, 26.329f, 14.162f, 26.479f, 14.162f)
            curveTo(26.629f, 14.162f, 26.778f, 14.082f, 26.629f, 13.978f)
            curveTo(26.479f, 13.873f, 26.047f, 13.672f, 26.047f, 13.672f)
            close()
        }
        path(fill = SolidColor(Color(0xFFFFD018))) {
            moveTo(22.054f, 16.116f)
            curveTo(22.054f, 16.116f, 20.831f, 18.277f, 20.612f, 18.389f)
            curveTo(20.394f, 18.5f, 20.231f, 18.523f, 20.12f, 18.389f)
            curveTo(20.008f, 18.254f, 19.997f, 18.749f, 20.12f, 18.885f)
            curveTo(20.243f, 19.02f, 20.612f, 19.02f, 20.817f, 18.779f)
            curveTo(20.817f, 18.779f, 20.85f, 19.387f, 21.17f, 19.846f)
            curveTo(21.489f, 20.304f, 21.622f, 20.177f, 21.622f, 20.436f)
            curveTo(21.622f, 20.696f, 21.698f, 21.039f, 21.795f, 21.039f)
            curveTo(21.893f, 21.039f, 21.968f, 21.854f, 21.795f, 21.854f)
            curveTo(21.622f, 21.854f, 22.196f, 21.921f, 22.446f, 21.717f)
            curveTo(22.697f, 21.513f, 22.804f, 21.358f, 22.75f, 21.358f)
            curveTo(22.697f, 21.358f, 22.054f, 21.02f, 22.054f, 20.78f)
            curveTo(22.054f, 20.541f, 21.622f, 20.354f, 21.622f, 19.999f)
            curveTo(21.622f, 19.643f, 21.398f, 19.221f, 21.398f, 19.053f)
            curveTo(21.398f, 18.885f, 21.59f, 19.118f, 21.795f, 18.958f)
            curveTo(22.001f, 18.799f, 22.054f, 18.389f, 22.054f, 18.389f)
            curveTo(22.054f, 18.389f, 21.73f, 18.606f, 21.622f, 18.497f)
            curveTo(21.514f, 18.389f, 21.173f, 18.174f, 21.398f, 17.806f)
            curveTo(21.622f, 17.439f, 22.054f, 16.116f, 22.054f, 16.116f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF5EAA22)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(24.174f, 9.302f)
            curveTo(24.174f, 9.302f, 23.736f, 9.497f, 23.882f, 9.787f)
            curveTo(24.028f, 10.076f, 24.081f, 10.204f, 24.174f, 10.14f)
            curveTo(24.268f, 10.076f, 24.924f, 9.955f, 24.777f, 9.629f)
            curveTo(24.63f, 9.302f, 24.322f, 9.302f, 24.322f, 9.302f)
            horizontalLineTo(24.174f)
            close()
        }
        path(fill = SolidColor(Color(0xFFFFD018))) {
            moveTo(25.694f, 9.146f)
            curveTo(25.694f, 9.146f, 25.115f, 8.89f, 25.308f, 9.146f)
            curveTo(25.501f, 9.402f, 25.748f, 9.537f, 25.925f, 9.537f)
            curveTo(26.103f, 9.537f, 26.472f, 9.484f, 26.287f, 9.38f)
            curveTo(26.103f, 9.277f, 25.694f, 9.146f, 25.694f, 9.146f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF5EAA22)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(19.981f, 15.801f)
            curveTo(19.984f, 15.785f, 19.966f, 15.774f, 19.954f, 15.785f)
            curveTo(19.833f, 15.9f, 19.473f, 16.283f, 19.626f, 16.616f)
            curveTo(19.809f, 17.014f, 19.992f, 17.152f, 19.992f, 17.152f)
            curveTo(19.992f, 17.152f, 20.103f, 17.76f, 20.334f, 17.926f)
            curveTo(20.334f, 17.926f, 20.643f, 17.91f, 20.658f, 17.437f)
            curveTo(20.658f, 17.437f, 21.184f, 17.282f, 21.338f, 17.611f)
            curveTo(21.338f, 17.611f, 21.236f, 17.647f, 21.236f, 17.926f)
            curveTo(21.236f, 18.205f, 21.474f, 18.507f, 21.474f, 18.507f)
            curveTo(21.474f, 18.507f, 21.583f, 17.545f, 22.072f, 16.926f)
            curveTo(22.561f, 16.306f, 22.701f, 16.183f, 22.701f, 16.183f)
            verticalLineTo(15.486f)
            curveTo(22.701f, 15.486f, 21.689f, 16.311f, 21.474f, 16.996f)
            curveTo(21.474f, 16.996f, 20.964f, 17.013f, 20.757f, 16.926f)
            curveTo(20.55f, 16.838f, 21.016f, 16.694f, 20.757f, 16.382f)
            curveTo(20.499f, 16.07f, 20.617f, 16.821f, 20.334f, 16.616f)
            curveTo(19.891f, 16.493f, 19.951f, 15.966f, 19.981f, 15.801f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF5EAA22)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(22.187f, 15.195f)
            lineTo(27.371f, 15.195f)
            verticalLineTo(18.362f)
            curveTo(27.371f, 18.362f, 26.949f, 20.951f, 24.691f, 22.226f)
            curveTo(24.691f, 22.226f, 22.504f, 20.933f, 22.187f, 18.362f)
            verticalLineTo(15.195f)
            close()
        }
        group(
            clipPathData = PathData {
                moveTo(22.187f, 15.195f)
                lineTo(27.371f, 15.195f)
                verticalLineTo(18.362f)
                curveTo(27.371f, 18.362f, 26.949f, 20.951f, 24.691f, 22.226f)
                curveTo(24.691f, 22.226f, 22.504f, 20.933f, 22.187f, 18.362f)
                verticalLineTo(15.195f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF58A5FF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(24.652f, 15.024f)
                lineTo(22.386f, 19.724f)
                lineTo(25.458f, 16.935f)
                lineTo(27.573f, 20.439f)
                verticalLineTo(15.024f)
                lineTo(25.458f, 16.757f)
                lineTo(24.652f, 15.024f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(24.58f, 18.414f)
                curveTo(24.58f, 18.32f, 24.656f, 18.245f, 24.749f, 18.245f)
                curveTo(24.843f, 18.245f, 24.918f, 18.32f, 24.918f, 18.414f)
                verticalLineTo(21.432f)
                curveTo(24.918f, 21.525f, 24.843f, 21.601f, 24.749f, 21.601f)
                curveTo(24.656f, 21.601f, 24.58f, 21.525f, 24.58f, 21.432f)
                lineTo(24.58f, 18.414f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(23.993f, 19.158f)
                curveTo(23.901f, 19.158f, 23.826f, 19.083f, 23.826f, 18.992f)
                curveTo(23.826f, 18.9f, 23.901f, 18.826f, 23.993f, 18.826f)
                horizontalLineTo(25.52f)
                curveTo(25.611f, 18.826f, 25.686f, 18.9f, 25.686f, 18.992f)
                curveTo(25.686f, 19.083f, 25.611f, 19.158f, 25.52f, 19.158f)
                horizontalLineTo(23.993f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(24.816f, 21.489f)
                lineTo(24.685f, 21.595f)
                curveTo(24.492f, 21.361f, 24.316f, 21.248f, 24.161f, 21.248f)
                curveTo(23.932f, 21.248f, 23.746f, 21.057f, 23.594f, 20.695f)
                lineTo(23.75f, 20.631f)
                curveTo(23.879f, 20.937f, 24.018f, 21.08f, 24.161f, 21.08f)
                curveTo(24.377f, 21.08f, 24.594f, 21.219f, 24.816f, 21.489f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD018)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(23.443f, 20.119f)
                curveTo(23.442f, 20.118f, 23.441f, 20.119f, 23.441f, 20.12f)
                verticalLineTo(20.936f)
                curveTo(23.441f, 20.938f, 23.442f, 20.938f, 23.443f, 20.938f)
                lineTo(24.057f, 20.685f)
                curveTo(24.058f, 20.685f, 24.058f, 20.683f, 24.057f, 20.683f)
                lineTo(23.443f, 20.119f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(24.677f, 21.489f)
                lineTo(24.808f, 21.595f)
                curveTo(25.001f, 21.361f, 25.177f, 21.248f, 25.332f, 21.248f)
                curveTo(25.561f, 21.248f, 25.747f, 21.057f, 25.898f, 20.695f)
                lineTo(25.742f, 20.631f)
                curveTo(25.614f, 20.937f, 25.474f, 21.08f, 25.332f, 21.08f)
                curveTo(25.116f, 21.08f, 24.899f, 21.219f, 24.677f, 21.489f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD018)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(26.049f, 20.119f)
                curveTo(26.051f, 20.118f, 26.052f, 20.119f, 26.052f, 20.12f)
                verticalLineTo(20.936f)
                curveTo(26.052f, 20.938f, 26.051f, 20.938f, 26.05f, 20.938f)
                lineTo(25.436f, 20.685f)
                curveTo(25.435f, 20.685f, 25.435f, 20.683f, 25.436f, 20.683f)
                lineTo(26.049f, 20.119f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(24.408f, 17.059f)
                horizontalLineToRelative(0.676f)
                verticalLineToRelative(1.007f)
                horizontalLineToRelative(-0.676f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun PitcairnIslandsPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.PitcairnIslands,
            contentDescription = "Pitcairn Islands Flag"
        )
    }
}
